<template>
    <div>
        <b-row>
            <b-col cols="12">
                <div class="border p-3 mb-4 rounded">
                    <b-row>
                        <b-col cols="12" md="4">
                            <b-form-group :label="$t('plate')">
                                <p class="form-control-static">
                                    {{ formData.car ? isNotNullValue(formData.car.plate) : '-' }}
                                </p>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-form-group :label="$t('type')">
                                <p class="form-control-static">
                                    {{ formData.car ? getLocaleText(formData.car, 'type_name') : '-' }}
                                </p>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-form-group :label="$t('kilometer')">
                                <p class="form-control-static">
                                    {{ formData.car ? isNotNullValue(formData.car.kilometer) : '-' }}
                                </p>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-form-group :label="$t('gear')">
                                <p class="form-control-static">
                                    {{ formData.car ? getLocaleText(formData.car, 'gear_name') : '-' }}
                                </p>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-form-group :label="$t('deliverer')">
                                <p class="form-control-static">
                                    {{ isNotNullValue(formData.deliverer) }}
                                </p>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-form-group :label="$t('car_responsible')">
                                <p class="form-control-static">
                                    {{ formData.car ? isNotNullValue(formData.car.responsible) : '-' }}
                                </p>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-form-group :label="$t('car_receiver')">
                                <p class="form-control-static">
                                    {{ isNotNullValue(formData.receiver) }}
                                </p>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4">
                            <b-form-group :label="$t('status')">
                                <p class="form-control-static">
                                    {{ getLocaleText(formData,'status_name') }}
                                </p>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" md="4" v-if="formData.reason">
                            <b-form-group :label="$t('reason_for_rejection')">
                                <p class="form-control-static">
                                    {{ isNotNullValue(formData.reason) }}
                                </p>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>

        <hr class="my-4">

        <b-row>
            <b-col cols="12" md="6">
                <div class="border px-4 pt-4 pb-3 rounded h-100">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h5 class="m-0">
                            {{ $t('start_kilometer') }} {{ formData.start_kilometer }}
                        </h5>
                    </div>
                    <b-row>
                        <b-col
                            cols="12"
                            sm="6"
                            md="6"
                            v-for="(file, index) in deliverFilesLimited"
                            :key="file.uuid || file.id || index"
                            class="mb-3"
                        >
                            <b-card no-body class="shadow-sm h-100">
                                <div class="p-2 text-center">
                                    <b-img
                                        v-if="imageUrls[file.uuid]"
                                        :src="imageUrls[file.uuid]"
                                        fluid
                                        thumbnail
                                        class="mb-2 img-fluid rounded"
                                        style="max-height: 200px; object-fit: cover; cursor: pointer;"
                                        @click="openImageModal(file)"
                                    />
                                    <div class="small text-truncate">
                                        {{ file.label || file.file_name || $t('file') }}
                                    </div>
                                </div>
                            </b-card>
                        </b-col>

                        <b-col cols="12" v-if="formLoading">
                            <p class="text-muted mb-0">
                                {{ $t('loading') }}...
                            </p>
                        </b-col>
                    </b-row>
                </div>
            </b-col>

            <b-col cols="12" md="6" class="mt-3 mt-md-0">
                <div class="border px-4 pt-4 pb-3 rounded h-100">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h5 class="m-0">
                            {{ $t('end_kilometer') }} {{ formData.end_kilometer }}
                        </h5>
                    </div>

                    <b-row>
                        <b-col
                            cols="12"
                            sm="6"
                            md="6"
                            v-for="(file, index) in receiverFilesLimited"
                            :key="file.uuid || file.id || index"
                            class="mb-3"
                        >
                            <b-card no-body class="shadow-sm h-100">
                                <div class="p-2 text-center">
                                    <b-img
                                        v-if="imageUrls[file.uuid]"
                                        :src="imageUrls[file.uuid]"
                                        fluid
                                        thumbnail
                                        class="mb-2 img-fluid rounded"
                                        style="max-height: 200px; object-fit: cover; cursor: pointer;"
                                        @click="openImageModal(file)"
                                    />
                                    <div class="small text-truncate">
                                        {{ file.label || file.file_name || $t('file') }}
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>

        <CommonModal
            ref="openImageModal"
            size="xl"
            :onHideOnlyX="true"
            @bHideModalHeaderClose="closeModal"
        >
            <template v-slot:CommonModalTitle>
                <span>
                    {{ selectedFileText }}
                </span>
            </template>

            <template v-slot:CommonModalContent>
                <div class="text-center">
                    <b-img
                        v-if="selectedImageUrl"
                        :src="selectedImageUrl"
                        fluid
                        class="mb-3"
                        style="max-height: 75vh; object-fit: contain;"
                    />
                    <p v-else class="text-muted">
                        {{ $t('image_not_loaded') }}
                    </p>
                </div>
            </template>
        </CommonModal>
    </div>
</template>

<script>
// Services
import CarReservationService from "@/services/CarReservationService";

export default {
    props: {
        formId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            formData: {
                car: null,
                deliver_files: [],
                receiver_files: [],
                start_kilometer: null,
                end_kilometer: null,
            },
            formLoading: false,
            imageUrls: {},
            selectedFile: null,
            selectedImageUrl: null,
        };
    },
    async created() {
        await this.get(this.formId);
    },
    computed: {
        deliverFilesLimited() {
            return this.formatFileList(this.formData.deliver_files);
        },

        receiverFilesLimited() {
            return this.formatFileList(this.formData.receiver_files);
        },

        selectedFileText() {
            if (!this.selectedFile) return "";
            return this.selectedFile.label || this.selectedFile.file_name || this.$t("file");
        },
    },
    methods: {
        async get(id) {
            this.formLoading = true;
            try {
                const response = await CarReservationService.getCarReservationDetail(id);
                this.formData = response.data.data || {};

                await this.loadImages();
            } catch (error) {
                if (error?.data?.message) {
                    this.$toast.error(this.$t("api." + error.data.message));
                }
            } finally {
                this.formLoading = false;
            }
        },

        async loadImages() {
            const allFiles = [
                ...this.deliverFilesLimited,
                ...this.receiverFilesLimited,
            ];

            const validFiles = allFiles.filter(file => file && file.uuid);

            const uniqueFiles = [];
            const uuidList = [];

            for (const file of validFiles) {
                if (!uuidList.includes(file.uuid)) {
                    uuidList.push(file.uuid);
                    uniqueFiles.push(file);
                }
            }

            for (const file of uniqueFiles) {
                try {
                    const response = await CarReservationService.getImageUrl(file.uuid);
                    const objectUrl = URL.createObjectURL(response.data);

                    this.$set(this.imageUrls, file.uuid, objectUrl);
                } catch (error) {
                    if (error?.data?.message) {
                        this.$toast.error(this.$t("api." + error.data.message));
                    }
                }
            }
        },

        async openImageModal(file) {
            if (!file || !file.uuid) return;

            this.selectedFile = file;
            this.selectedImageUrl = this.imageUrls[file.uuid] || null;

            if (!this.selectedImageUrl) {
                try {
                    const response = await CarReservationService.getImageUrl(file.uuid);
                    const objectUrl = URL.createObjectURL(response.data);

                    this.$set(this.imageUrls, file.uuid, objectUrl);
                    this.selectedImageUrl = objectUrl;
                } catch (error) {
                    if (error?.data?.message) {
                        this.$toast.error(this.$t("api." + error.data.message));
                    }
                }
            }

            this.$refs.openImageModal.$refs.commonModal.show();
        },

        closeModal() {
            this.selectedFile = null;
            this.selectedImageUrl = null;

            if (this.$refs.openImageModal && this.$refs.openImageModal.$refs.commonModal) {
                this.$refs.openImageModal.$refs.commonModal.hide();
            }
        },
        formatFileList(files) {
            let arr = Array.isArray(files)
                ? files
                : (files ? Object.values(files) : []);

            return arr
                .filter(Boolean)
                .sort((a, b) => (a.order || 0) - (b.order || 0))
                .slice(0, 5);
        },
    },
};
</script>
